import { createDropdownHelpers } from './chunk-ZAI4VYHK.mjs';
import { ECoursingType } from './chunk-2YTERMNH.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';

// src/helpers/factories/menu/coursingTypesDropdownFactory.ts
var getMenuCoursingTypesTranslation = (s) => i18n_config_default.t(`menuScreen.menuTypeDetails.basic.coursingTypeOptions.${s}`);
var {
  valueToEnum: coursingTypeValueToCoursingType,
  enumToValue: coursingTypeToCoursingTypeValue,
  dropdownOptions: coursingTypeDropdownOptions
} = createDropdownHelpers(ECoursingType, getMenuCoursingTypesTranslation);

export { coursingTypeDropdownOptions, coursingTypeToCoursingTypeValue, coursingTypeValueToCoursingType, getMenuCoursingTypesTranslation };
